import { ProblemSchema } from '@clearroute/shared'
import type { z } from 'zod'

/**
 * Re-exports + safe-parse helper for RFC 7807 Problem bodies.
 *
 * `parseProblem` never throws: it returns `null` on any unrecognised input.
 * Callers (see `api.ts`) fall back to a generic `urn:clearroute:error:unknown`
 * when the server sends an HTML / truncated body — mitigates T-2-PROB
 * (tampered bodies must not escape the parse boundary).
 */

export { ProblemSchema } from '@clearroute/shared'

export type ParsedProblem = z.infer<typeof ProblemSchema>

export function parseProblem(raw: unknown): ParsedProblem | null {
  const result = ProblemSchema.safeParse(raw)
  return result.success ? result.data : null
}
